// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionFrontInfo-module--container--1x7SI","headerText":"SectionFrontInfo-module--headerText--2KAaZ"};